import { Camera } from '@starryui10/images/icons/Camera';
import { strings } from '@starryui10/localisation';
import * as React from 'react';
import { ContainerDiv, ContentDiv } from './UpdatePhotoOverlay.styles';

interface IUpdatePhotoOverlayProps {
    size: avatar.ThumbnailSize;
    actualSize: number;
    isFullSize: boolean;
    show: boolean;
    onUploadClick: () => void;
}

export const UpdatePhotoOverlay = React.forwardRef<HTMLDivElement, IUpdatePhotoOverlayProps>(
    ({ isFullSize, size, actualSize, show, onUploadClick }, ref) => {
        const [isFocused, setIsFocused] = React.useState(false);

        const handleOnClick = (e: React.MouseEvent) => {
            e.stopPropagation();
            if (onUploadClick) {
                onUploadClick();
            }
        };

        const handleOnKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
            e.stopPropagation();
            const target = e.target as HTMLElement;

            if (e.nativeEvent.code === 'Space' || e.nativeEvent.code === 'Enter') {
                target.click();
            }
        };

        return (
            <ContainerDiv
                ref={ref}
                role="button"
                tabIndex={0}
                aria-label={strings.Action_Update}
                IsFullSize={isFullSize}
                Size={actualSize}
                Show={show || isFocused}
                onClick={handleOnClick}
                onKeyPress={handleOnKeyPress}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            >
                <ContentDiv IsFullSize={isFullSize} IsLargest={size === 'Largest'} ActualSize={actualSize}>
                    <Camera />
                    {(size === 'Largest' || isFullSize) && <>{strings.Action_Update}</>}
                </ContentDiv>
            </ContainerDiv>
        );
    }
);
